import { Grid, GridSize, makeStyles } from "@material-ui/core";
import AttachmentModel from "api/models/AttachmentModel";
import ContractRowModel from "api/models/ContractRowModel";
import { lang } from "i18nLang";
import { observer } from "mobx-react";
import { MessageStore, MovimentsAttachmentStore } from "store";
import AttachmentCard from "./AttachmentCard";
import UploadButton from "./UploadButton";

const useStyles = makeStyles({
  container: {
    marginTop: "0.25rem",
  },

  paddingItem: { padding: "5px 0px" },
});

interface IAttachmentsMovimentProps {
  index: number;
  applyChanges: boolean;
  cardColumnSize?: GridSize;
  selectedRow?: ContractRowModel;
}

const AttachmentsMoviment = observer(
  ({
    index,
    applyChanges,
    cardColumnSize = 8,
    selectedRow,
  }: IAttachmentsMovimentProps) => {
    const classes = useStyles();
    const attachments = MovimentsAttachmentStore.getMovimentAttachments(index);

    const handleChangeFiles = (files: File[]) => {
      if (!MovimentsAttachmentStore.validadeAttachmentsCount(index, files)) {
        MessageStore.error(lang("attachments.errors.maximumFilesCount"));
        return;
      }

      const promises = Array.from(files).map((file) =>
        MovimentsAttachmentStore.uploadMovimentAttachment(index, file)
      );

      Promise.all(promises).then(() => {
        if (applyChanges && selectedRow) {
          MovimentsAttachmentStore.saveMovimentAttachments(index, [
            selectedRow,
          ]);
        }
      });
    };

    const handleDeleteCard = (attachment: AttachmentModel) => {
      MovimentsAttachmentStore.removeMovimentAttachment(index, attachment);
      if (attachment.isSaved() && applyChanges && selectedRow) {
        MovimentsAttachmentStore.saveMovimentAttachments(index, [selectedRow]);
      }
    };

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.paddingItem}>
          <UploadButton color={"#BDBDBD"} onChangeFiles={handleChangeFiles} />
        </Grid>
        {attachments.map((att) => (
          <Grid
            item
            xs={cardColumnSize}
            className={classes.paddingItem}
            key={att.uid}
          >
            <AttachmentCard attachment={att} onDelete={handleDeleteCard} />
          </Grid>
        ))}
      </Grid>
    );
  }
);

export default AttachmentsMoviment;
